import { __awaiter } from "tslib";
import { registerClient } from '@inrupt/oidc-client-ext';
export class ClientRegistrar {
    constructor(storageUtility) {
        this.storageUtility = storageUtility;
        this.storageUtility = storageUtility;
    }
    getClient(options, issuerConfig) {
        return __awaiter(this, void 0, void 0, function* () {
            // If client secret and/or client id are stored in storage, use those.
            const [storedClientId, storedClientSecret, storedClientName, storedClientType] = yield Promise.all([
                this.storageUtility.getForUser(options.sessionId, 'clientId', {
                    secure: false,
                }),
                this.storageUtility.getForUser(options.sessionId, 'clientSecret', {
                    secure: false,
                }),
                this.storageUtility.getForUser(options.sessionId, 'clientName', {
                    secure: false,
                }),
                this.storageUtility.getForUser(options.sessionId, 'clientType', {
                    secure: false,
                }),
            ]);
            if (storedClientId) {
                return {
                    clientId: storedClientId,
                    clientSecret: storedClientSecret,
                    clientName: storedClientName,
                    clientType: storedClientType,
                };
            }
            try {
                const registeredClient = yield registerClient(options, issuerConfig);
                // Save info
                const infoToSave = {
                    clientId: registeredClient.clientId,
                    clientType: 'dynamic',
                };
                if (registeredClient.clientSecret) {
                    infoToSave.clientSecret = registeredClient.clientSecret;
                }
                if (registeredClient.idTokenSignedResponseAlg) {
                    infoToSave.idTokenSignedResponseAlg = registeredClient.idTokenSignedResponseAlg;
                }
                yield this.storageUtility.setForUser(options.sessionId, infoToSave, {
                    secure: false,
                });
                return registeredClient;
            }
            catch (error) {
                throw new Error(`Client registration failed: [${error}]`);
            }
        });
    }
}
//# sourceMappingURL=ClientRegistrar.js.map